import { useContext } from "react";
import SignInButton from "../SignInButton";
import "./styles.css";
import { useIntl } from "react-intl";
import { ThemeContext } from "../../context/ThemeContext";
const SignInBox = ({ expired }) => {
  const { isDarkMode } = useContext(ThemeContext);
  const intl = useIntl();
  const title = expired
    ? intl.formatMessage({
        id: "login.expired.welcome",
        defaultMessage: "Your session expired",
      })
    : intl.formatMessage({
        id: "login.welcome",
        defaultMessage: "Welcome to Truman!",
      });
  const description = expired
    ? intl.formatMessage({
        id: "login.expired.description",
        defaultMessage: "Your session expired, please log in again to continue",
      })
    : intl.formatMessage({
        id: "login.description",
        defaultMessage: "Bayer’s internal consent management tool",
      });

  return (
    <div className="box-container">
      <img
        src={
          isDarkMode
            ? "/ui/images/Truman-UI-corp-logo-dark-mode.svg"
            : "/ui/images/Truman-UI-corp-logo.svg"
        }
        alt="Bayer Logo"
        height={61}
      />
      <h6 className="heading">{title}</h6>
      <p className="p-consent">{description}</p>
      <SignInButton />
    </div>
  );
};

export default SignInBox;
